import { useTranslation } from "react-i18next";
import PageTitle from "../../../../components/PageTitle/PageTitle";
import DataTable from "./DataTable";

export default function ViewInvestor({id}){
    const { t } = useTranslation();

    return(
        <div>
            
            <PageTitle title={ t('inwardDividend.investorsDetails.view.pageTitle')} 
            // button={
            // <Link to="/app/inward-dividend/list"> 
            //     <Button
            //         variant="contained"
            //         size="medium"
            //         color="primary"
            //     >
            //         { t('inwardDividend.investorsDetails.view.listLink')}
            //     </Button>
            // </Link>}
             />
    <DataTable id={id} />
        </div>
    )
}